import * as _ from 'lodash'
import moment from 'moment'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
// import 'bootstrap-datepicker'
// import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css'
import ApexCharts from 'apexcharts'
import 'apexcharts/dist/apexcharts.css'

const meta = 'report_categories'
window[`fnc_${meta}`] = initReportCategoriesPage

document.addEventListener("loadPage", () => {
    const evMeta = document.querySelector('meta[name="eventListener"]')
    if (evMeta !== null && evMeta['content'] === meta) {
        document.addEventListener("appReady", () => {
            if (DEBUG) console.log((`Initializing ${meta} page`))
            window[`fnc_${meta}`]()
        })
    }
})

async function initReportCategoriesPage() {
    $('#loading-animation').removeClass('visually-hidden')
    $('.row.widget-container').each(function (idx, obj) {
        $(this).addClass('visually-hidden')
    })

    const prevAccounts = helpers.appSettingsGet('reportSelectedAccount') || 'all_accounts'
    const period = helpers.appSettingsGet('reportPeriodCat')

    let accounts: object[] = []

      if (prevAccounts == 'all_accounts') {
        accounts = _.filter(globals.vars.userData.accounts, function(o) {
            return o['archived'] === false && o['statistic'] === true
        })
    } else if (prevAccounts == 'all_favorites') {
        accounts = _.filter(globals.vars.userData.accounts, function(o) {
            return o['archived'] === false && o['statistic'] === true && o['favorite'] === true
        })
    } else {
        accounts = _.filter(globals.vars.userData.accounts, function(o) {
            return o['archived'] === false && o['_id'] === prevAccounts
        })        
    }

    if (accounts.length == 0) {
        accounts = _.filter(globals.vars.userData.accounts, function(o) {
            return o['archived'] === false && o['statistic'] === true
        })
    }
        
    $('#report-account').val(prevAccounts)

    $('#report-account').off().on('change', function(e) {
        helpers.appSettingsSet({'reportSelectedAccount': $('#report-account').val() as string})
        setTimeout(initReportCategoriesPage, 100)
    })

    $('#report-period-select').off().on('change', function(e) {
        e.preventDefault()       
        helpers.appSettingsSet({'reportPeriodCat': $(this).val()})
        setTimeout(initReportCategoriesPage, 100)
    })
 
    const params = {
        accounts: _.map(accounts, function(o) { return o['_id']}),
        period: period,
        _csrf: $("meta[name=_csrf]").attr("content")
    }

    $.ajax({
        url: '/json/reports/categories',
        method: 'POST',
        data: params,
        success: function (response) {  
            if (DEBUG) console.log(response)

            if (typeof response['periods'] === 'undefined' || typeof response['data'] === 'undefined') {               
                return $('#loading-animation').addClass('visually-hidden')
            }

            /** period select form */
            $('#report-period-select').html('')

            const _options = _.map(response['periods'], function(o) {
                return { text: o, value: o }
            })

            _options.unshift({ text: global.i18n.t('reports.12m'), value: '12m' })

            let _prevFound = false

            _.map(_options, function(o) {
                if (period == o['value'])
                    _prevFound = true

                $('#report-period-select').append(`<option value="${o['value']}">${o['text']}</option>`)
            })

            if (_prevFound)
                $('#report-period-select').val(period)
            else
                helpers.appSettingsSet({'reportPeriodCat': '12m'})
            /** end of period selection */

            $('.header-title').text($( "#report-period-select option:selected" ).text())

            let output = `
                <tr>
                    <th></th>
                    <th>Category</th>
                    <th colspan="2" class="text-nowrap text-end flex-fill">${global.i18n.t('reports.total')}</th>

            `

            let firstDate
  
            if (/^\d{4}$/.test(period))
                /** displaying a full year */
                firstDate = moment(period).startOf('year').toISOString()
             else
                /** failover to last 12m */
                firstDate = moment().startOf('month').subtract(11, 'month').toISOString()

            const Months = {}

            for (let i=0; i<12; i++) {
                const _p = moment(firstDate).local().add(i, 'month').local().format('YYYY-MM')
                Months[_p] = 1

                output += `
                    <th colspan="2" class="text-nowrap text-end flex-fill">${helpers.ucFirst(moment(firstDate).add(i, 'month').local().format('MMM YY').replace(/\./, ''))}</th>
                `
            }

            output += '</tr>'

            $('#categories-head').html(output)


            output = ''

            for (let i=0; i<response['data'].length; i++) {
                const row = response['data'][i]

                const _mark = typeof row['id'] === 'undefined' ? ' bolder text-orange' : ''
                const cls = i % 2 == 1 ? 'bg-light' : ''

                output += `
                    <tr class="align-middle ${cls}" data-category="${row['id']}">
                        <th scope="row" class="text-center justify-content-center fw-bold" style="width: 22px"><i class="${row['icon']}${_mark} fa-2x"></i></th>
                        <td class="text-nowrap fw-bold flew-grow-1">${row['name']}</td>
                    `
                /** Total column **/
                const _totalI = typeof row['sums']['total'] !== 'undefined' && !_.isEmpty(row['sums']['total']) ? parseFloat(row['sums']['total']['income']) : 0
                const _totalE = typeof row['sums']['total'] !== 'undefined' && !_.isEmpty(row['sums']['total']) ? parseFloat(row['sums']['total']['expenses']) : 0
                const _totalP = typeof row['sums']['total'] !== 'undefined' && !_.isEmpty(row['sums']['total']) ? parseFloat(row['sums']['total']['profit']) : 0
                
                const cls1 = _totalI == 0 ? 'text-muted' : _totalI > 0 ? 'text-success fw-bold' : ''
                const cls2 = _totalE == 0 ? 'text-muted' : _totalE < 0 ? 'text-danger fw-bold' : ''

                output += `<td class="text-nowrap flex-fill text-end" style="border: 0 20px 0 0 !important" data-plugin="tippy" data-tippy-placement="bottom" data-tippy="" data-tippy-distance="0" data-tippy-allowHTML="true" data-tippy-content="<i class='mdi mdi-sigma'></i>= ${helpers.anonFigures(helpers.fmtCurrency(_totalP))}"><div class="amount ${cls1}">${helpers.anonFigures(helpers.fmtCurrency(_totalI))}</div><div class="amount ${cls2}">${helpers.anonFigures(helpers.fmtCurrency(_totalE))}</div></td>`
                output += '<td class="bg-muted border-0 p-0 m-0" style="min-width: 1px !important; max-width: 1px !important;"></td>'

                for (const k in Months) {
                    let income = 0
                    let expenses = 0
                    let profit = 0

                    if (typeof row['sums']['per_month'][k] !== 'undefined') {
                        income      = parseFloat(row['sums']['per_month'][k]['income'])
                        expenses    = parseFloat(row['sums']['per_month'][k]['expenses'])
                        profit      = parseFloat(row['sums']['per_month'][k]['profit'])

                    }
                   
                    const cls3 = income == 0 ? 'text-muted' : income > 0 ? 'text-success fw-bold' : ''
                    const cls4 = expenses == 0 ? 'text-muted' : expenses < 0 ? 'text-danger fw-bold' : ''

                    output += `<td class="text-nowrap flex-fill text-end re1" data-period="${k}" data-plugin="tippy" data-tippy-placement="bottom" data-tippy="" data-tippy-distance="0" data-tippy-allowHTML="true" data-tippy-content="<i class='mdi mdi-sigma'></i>= ${helpers.anonFigures(helpers.fmtCurrency(profit))}"><div class="amount ${cls3}">${helpers.anonFigures(helpers.fmtCurrency(income))}</div><div class="amount ${cls4}">${helpers.anonFigures(helpers.fmtCurrency(expenses))}</div></td>`
                    output += '<td class="border-0 p-0 m-0" style="min-width: 1px !important; max-width: 1px !important; background-color: lightgray;"></td>'
                }

                output += '</tr>'
            }

            $('#categories-table').html(output)


            tippy('[data-plugin="tippy"]')

            //ANCHOR Category click
            $('td[data-period]').each(function (idx, obj) {
                $(this).off().on('dblclick', (e) => {
                    e.preventDefault()

                    window.getSelection().removeAllRanges()

                    const _period = $(this).attr('data-period')

                    helpers.appSettingsSet({'transactionsStartTime': moment(_period).startOf('month').toISOString()})
                    helpers.appSettingsSet({'transactionsEndTime': moment(_period).endOf('month').toISOString()})
                    helpers.appSettingsDelete('transactionsUntilToday')

                    if ($('#report-account').val() == 'all_accounts') {
                        helpers.appSettingsDelete('transactionsAccountId')
                        helpers.appSettingsSet({'transactionsFavoriteAccountsOnly': false})

                    } else if ($('#report-account').val() == 'all_favorites') {
                        helpers.appSettingsDelete('transactionsAccountId')
                        helpers.appSettingsSet({'transactionsFavoriteAccountsOnly': true})
                    } else {
                        helpers.appSettingsSet({'transactionsFavoriteAccountsOnly': false})
                        helpers.appSettingsSet({'transactionsAccountId': $('#report-account').val()})
                    }

                    if ($(this).closest('tr').attr('data-category') !== 'undefined') {
                        helpers.appSettingsSet({'transactionsCategoryFilter': $(this).closest('tr').attr('data-category')})
                        helpers.appSettingsDelete('transactionsFilters')
                    } else {
                        helpers.appSettingsDelete('transactionsCategoryFilter')
                        helpers.appSettingsSet({'transactionsFilters': ['#filter_uncategorized']})
                    }

                    window.location.href = '/transactions'
                })
            })

            // cls = total_rev >= 0 ? 'text-success' : 'text-danger'
            // $('#income-rev').text(helpers.anonFigures((total_rev > 0 ? '+' : '')+helpers.fmtCurrency(total_rev, 'EUR') ))
            // $('#income-rev').addClass(cls)


            $('#loading-animation').addClass('visually-hidden')
            $('.row.widget-container').each(function (idx, obj) {
                $(this).removeClass('visually-hidden')
            })


        },
        error: function (err) {
            console.log(err)
        }
    })
}

function drawRevenuesBarChart(data) {
    const _income = _.map(data, function(o) {
        return { x: helpers.ucFirst(moment(o['period']).format('MMM').replace(/\./, "")), y: o['income'] }
    })

    const _expenses = _.map(data, function(o) {
        return { x: helpers.ucFirst(moment(o['period']).format('MMM').replace(/\./, "")), y: Math.abs(o['expenses']) }
    })

    const periods = _.map(data, function(o) {
        return helpers.ucFirst(moment(o['period']).format('MMM').replace(/\./, ""))
    })

    var colors = ['#3bafda','#1abc9c', '#CED4DC']
    var dataColors = $("#apex-column-1").data('colors')
    if (dataColors) {
        colors = dataColors.split(",")
    }

    const options = {
        chart: {
            height: 195,
            type: 'bar',
            toolbar: {
                show: false
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                endingShape: 'rounded',
                columnWidth: '55%',
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        colors: colors,
        series: [
            {
                name: global.i18n.t('dashboard.widgets.income'),
                data: _income
            },
            {
                name: global.i18n.t('dashboard.widgets.expenses'),
                data: _expenses
            }
        ],
        xaxis: {
            categories: periods,
        },
        legend: {
            show: false,
            offsetY: 5,
        },
        yaxis: {
            decimalsInFloat: 2,
            labels: {
                show: true,
                showDuplicates: false,
                formatter: (value) => { return helpers.anonFigures(helpers.fmtCurrency(value, undefined, 0)) },
            },
            title: {
                text: '',
            }
        },
        fill: {
            opacity: 1
    
        },
        grid: {
            row: {
                colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.2
            },
            borderColor: '#f1f3fa',
            padding: {
                bottom: 10
            }
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return helpers.fmtCurrency(val)
                }
            }
        }
    }
    
    if (typeof globals.vars.charts['apex1'] === 'undefined') {
        globals.vars.charts['apex1'] = new ApexCharts(document.querySelector("#apex-column-1"), options)
        globals.vars.charts['apex1'].render()
    } else {
        globals.vars.charts['apex1'].updateSeries([
            {
                data: _income
            }, {
                data: _expenses
            }
        ], false)

        globals.vars.charts['apex1'].updateOptions({ xaxis: { categories: periods } }, true)   
    }
}


function drawDonutIncome(data) {
    const total_income = _.sumBy(data, function (o) {
        return o['income']
    })
    
    const options = {
        chart: {
            height: 150,
            type: 'donut',
        },
        series: _.map(data, function(o) { return o['income'] / total_income *100 }),
        labels: _.map(data, function(o) { return o['_id']['name'] }),
        theme: {
            palette: 'palette2'
        },
        legend: {
            show: false,
            position: 'bottom',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0,
            offsetY: 7
        },
        dataLabels: {
            enabled: false,
            formatter: function (val) {
              return val + "%"
            },
            dropShadow: {
         
            }
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return new Intl.NumberFormat(globals.vars.locales, { minimumFractionDigits: 2, maximumFractionDigits: 2, style: "percent" }).format(val/100)
                }
            }
        },
        title: {
            text: undefined,
            align: 'center',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              fontFamily:  undefined,
              color:  '#263238'
            },
        },
        responsive: [{
            breakpoint: 600,
            options: {
                chart: {
                    height: 240
                },
                legend: {
                    show: false
                },
            }
        }]

    }

    if (typeof globals.vars.charts['apex2'] === 'undefined') {
        globals.vars.charts['apex2'] = new ApexCharts(document.querySelector("#apex-pie-1"), options)
        globals.vars.charts['apex2'].render()
    } else {
        globals.vars.charts['apex2'].updateSeries(_.map(data, function(o) { return o['income'] / total_income *100 }), true)
        globals.vars.charts['apex2'].updateOptions({ labels: _.map(data, function(o) { return o['_id']['name'] })})       
    }
}



function drawDonutExpenses(data) {
    const total_expenses = _.sumBy(data, function (o) {
        return o['expenses']
    })

    const options = {
        chart: {
            height: 150,
            type: 'donut',
        },
        series: _.map(data, function(o) { return o['expenses'] / total_expenses *100 }),
        labels: _.map(data, function(o) { return o['_id']['name'] }),
        theme: {
            palette: 'palette2'
        },
        legend: {
            show: false,
            position: 'bottom',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0,
            offsetY: 7
        },
        dataLabels: {
            enabled: false,
            formatter: function (val) {
              return val + "%"
            },
            dropShadow: {
         
            }
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return new Intl.NumberFormat(globals.vars.locales, { minimumFractionDigits: 2, maximumFractionDigits: 2, style: "percent" }).format(val/100)
                }
            }
        },
        title: {
            text: undefined,
            align: 'center',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              fontFamily:  undefined,
              color:  '#263238'
            },
        },
        responsive: [{
            breakpoint: 600,
            options: {
                chart: {
                    height: 240
                },
                legend: {
                    show: false
                },
            }
        }]

    }

    if (typeof globals.vars.charts['apex3'] === 'undefined') {
        globals.vars.charts['apex3'] = new ApexCharts(document.querySelector("#apex-pie-2"), options)
        globals.vars.charts['apex3'].render()
    } else {
        globals.vars.charts['apex3'].updateOptions(options, true, true, true)
        globals.vars.charts['apex3'].updateOptions({ labels: _.map(data, function(o) { return o['_id']['name'] })})    
    }
}



function drawSavingsGauge(data) {
    let pct = '-'

    if (typeof data !== 'undefined') {
        const profit = data['profit']
        const income = data['income']

        pct = income == 0 ? '-' : (profit/income*100).toFixed(1)
    }

     const options = {
        chart: {
            height: 150,
            type: 'radialBar',
        },
        series: [pct],
        labels: [""],
        plotOptions: {
            radialBar: {
                dataLabels: {
                    name: {
                        show: false,
                        // offsetY: -10,
                        // color: "#fff",
                        // fontSize: "13px"
                    },
                    value: {
                        // color: "#fff",
                        offsetY: +10,
                        fontSize: "22px",
                        show: true
                    }
                }
            }
        }
    }

    if (typeof globals.vars.charts['apex4'] === 'undefined') {
        globals.vars.charts['apex4'] = new ApexCharts(document.querySelector("#apex-gauge-1"), options)
        globals.vars.charts['apex4'].render()
    } else {
        globals.vars.charts['apex4'].updateOptions(options, true, true, true)  
    }
}


